import allCandidates from './data/candidates'
const districts = Object.keys(allCandidates)

module.exports = reset => {
    const { pathname, search } = window.location
    let answers = []
    let weightedAnswers = []
    let district

    let candidateApp = false
    if (pathname.startsWith('/candidate')) {
        candidateApp = true
    }

    if (!reset && search) {
        const params = search.replace('?', '').split('&')
        params.forEach(param => {
            let [ key, value ] = param.split('=')
            if (key && value) {
                if (key === 'vp') {
                    if (districts.includes(value)) {
                        district = value
                    }
                } else if (district) { // district has to be first value to search params to be valid
                    value = parseInt(value)
                    if (value === 2 || value === -2) {
                        weightedAnswers = [key]
                        value = value / 2
                    }
                    answers.push({
                        question: key,
                        answer: value,
                    })
                }
            }
        })
    }

    window.history.replaceState({ district, answers, weightedAnswers }, false)

    return {
        filters: {
            party: [],
            ageGroup: [],
            gender: [],
        },
        weightedAnswers,
        answers,
        district,
        candidateApp,
        candidateAppDone: false,
    }
}